import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import schoolImg from "../images/school_img_1.jpg";

import {
  FaAward,
  FaBookOpen,
  FaUsers,
  FaFlask,
  FaMicroscope,
  FaTrophy,
} from "react-icons/fa";

const AboutPage = () => {
  return (
    <div className="min-h-screen pb-10 ">
      <div className="min-h-screen bg-opacity-70">
        <Navbar />

        {/* Hero Section */}
        <section
          className="relative bg-center bg-cover"
          style={{ backgroundImage: `url(${schoolImg})` }}
        >
          {/* Overlay for better contrast */}
          <div className="absolute inset-0 bg-gray-900 opacity-70"></div>

          {/* Content over the background */}
          <div className="relative z-10 flex items-center justify-center p-10 m-5 mx-auto mt-10 overflow-hidden shadow-2xl rounded-3xl max-w-7xl">
            <div className="w-full max-w-6xl px-4 sm:px-6">
              <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
                {/* Left Section: Text Content */}
                <div className="flex flex-col justify-center text-center md:text-left">
                  <h1 className="text-4xl font-extrabold leading-tight tracking-tight text-white uppercase sm:text-4xl md:text-5xl lg:text-8xl">
                    Welcome to{" "}
                    <span className="text-yellow-500">Shinpex Academy</span>
                  </h1>
                  {/* <p className="mt-4 text-base font-medium text-gray-200 sm:text-lg md:text-xl">
                    Located in ilorin kwara State. We nurture the next
                    generation of innovators, job creators, and leaders through
                    world-class science education and hands-on experiences.
                  </p> */}
                  <div className="flex flex-wrap gap-4 mt-6">
                    <a
                      href="#mission"
                      className="p-3 text-sm font-bold tracking-widest text-center text-black uppercase transition bg-yellow-500 rounded-sm grow hover:bg-yellow-600"
                    >
                      Our Mission
                    </a>
                    <a
                      href="#vision"
                      className="p-3 text-sm font-bold tracking-widest text-center text-yellow-500 uppercase transition border border-yellow-500 rounded-sm grow hover:bg-yellow-500 hover:text-black"
                    >
                      Our Vision
                    </a>
                  </div>
                </div>

                {/* Right Section: Visual Block */}
                <div className="relative flex items-center sm:m-10">
                  <div className="absolute hidden bg-yellow-500 border-b-4 border-r-8 border-yellow-700 rounded-lg -top-10 md:-top-20 -left-10 sm:w-32 sm:h-32 lg:w-64 lg:h-64 rotate-12 sm:block"></div>
                  <div className="relative z-10 p-4 text-center -translate-x-1/2 bg-gray-800 border-b-4 border-r-8 shadow-2xl sm:p-6 -right-1/2 grow -rotate-2 rounded-xl border-slate-950">
                    <h2 className="text-2xl font-bold uppercase sm:text-3xl text-gray-50">
                      Bold. Strong. Raw.
                    </h2>
                    <p className="mt-1 text-sm font-light text-gray-400 sm:text-base">
                      Embrace minimalism with maximal impact.
                    </p>
                  </div>
                  <div className="absolute hidden bg-yellow-500 border-b-8 border-r-4 border-yellow-700 rounded-lg -bottom-10 md:-bottom-20 -right-16 sm:w-32 sm:h-32 lg:w-64 lg:h-64 -rotate-12 sm:block"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* New Students Section */}
        <section className="max-w-4xl px-4 mx-auto mt-10">
  <div className="relative overflow-hidden bg-gradient-to-br from-white to-gray-50 rounded-3xl shadow-2xl transform hover:scale-[1.02] transition-all duration-500">
    {/* Decorative Elements */}
    <div className="absolute top-0 right-0 w-32 h-32 transform translate-x-16 -translate-y-16 bg-yellow-500 rounded-full opacity-10"></div>
    <div className="absolute bottom-0 left-0 w-24 h-24 transform -translate-x-12 translate-y-12 bg-green-700 rounded-full opacity-10"></div>
    
    {/* Header */}
    <div className="relative p-8 bg-gradient-to-r from-yellow-500 via-yellow-600 to-yellow-500">
      <div className="absolute inset-0 bg-black opacity-10"></div>
      <div className="relative z-10 text-center">
        <h1 className="text-4xl font-extrabold tracking-tight text-black uppercase md:text-5xl">
          To Our Dear <span className="text-white">New Students</span>
        </h1>
        <div className="w-24 h-1 mx-auto mt-4 mb-4 bg-black"></div>
        <p className="text-lg font-medium text-gray-900 md:text-xl">
          Welcome to a world of exploration and discovery.
        </p>
      </div>
    </div>
    
    {/* Content */}
    <div className="relative p-8 md:p-12">
      <div className="space-y-6">
        <p className="text-lg leading-relaxed text-gray-800">
          At <span className="font-bold text-yellow-600">Shinpex Academy</span>, we encourage you to think critically,
          challenge assumptions, and cultivate a lifelong passion for learning that will shape your future.
        </p>
        
        <p className="text-lg leading-relaxed text-gray-800">
          Our programs are designed to inspire and challenge you, preparing you for prestigious universities and successful
          careers in STEM fields. Over the years, our alumni have gone on to make significant contributions in science, 
          medicine, engineering, and innovation across Africa and beyond.
        </p>
        
        {/* Expectations Card */}
        <div className="relative p-8 overflow-hidden shadow-xl bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl">
          <div className="absolute top-0 right-0 w-20 h-20 transform translate-x-10 -translate-y-10 bg-yellow-500 rounded-full opacity-20"></div>
          
          <h4 className="mb-6 text-3xl font-bold tracking-wide text-white uppercase">
            We Expect <span className="text-yellow-500">Excellence</span>
          </h4>
          
          <div className="grid gap-6 md:grid-cols-3">
            {/* Dedication */}
            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-yellow-500 rounded-full">
                <svg className="w-8 h-8 text-black" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <h5 className="mb-2 text-xl font-bold text-yellow-500">DEDICATION</h5>
              <p className="text-sm text-gray-300">Hard work and commitment to excellence</p>
            </div>
            
            {/* Respect */}
            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-green-700 rounded-full">
                <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                </svg>
              </div>
              <h5 className="mb-2 text-xl font-bold text-green-400">RESPECT</h5>
              <p className="text-sm text-gray-300">For others and our environment</p>
            </div>
            
            {/* Engagement */}
            <div className="text-center">
              <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-yellow-500 rounded-full">
                <svg className="w-8 h-8 text-black" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z" />
                </svg>
              </div>
              <h5 className="mb-2 text-xl font-bold text-yellow-500">ENGAGEMENT</h5>
              <p className="text-sm text-gray-300">Active participation in all activities</p>
            </div>
          </div>
        </div>
        
        {/* Call to Action */}
        <div className="p-6 text-center bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-2xl">
          <p className="mb-2 text-xl font-bold text-black">
            Together, let's make <span className="text-gray-900">Shinpex Academy</span> a beacon of academic excellence and innovation.
          </p>
        </div>
        
        {/* Signature */}
        <div className="pt-6 text-center border-t border-gray-200">
          <p className="mb-1 text-2xl font-bold text-gray-900">Mr & Mrs Abolakale</p>
          <p className="font-medium tracking-wide text-gray-600 uppercase">Director of Studies</p>
          <div className="w-16 h-1 mx-auto mt-2 bg-yellow-500"></div>
        </div>
      </div>
    </div>
  </div>
</section>

        <section className="relative py-20 overflow-hidden bg-gray-100">
  {/* Background Decorative Elements */}
  <div className="absolute w-32 h-32 bg-yellow-500 rounded-full top-10 left-10 opacity-10 animate-pulse"></div>
  <div className="absolute w-48 h-48 bg-green-700 rounded-full bottom-10 right-10 opacity-10 animate-pulse"></div>
  
  <div className="container relative z-10 px-4 mx-auto">
    {/* Section Header */}
    <div className="mb-16 text-center">
      <h2 className="mb-4 text-5xl font-extrabold tracking-tight text-gray-900 uppercase md:text-6xl">
        What Makes <span className="text-yellow-500">Shinpex Academy</span> Stand Out
      </h2>
      <div className="w-32 h-1 mx-auto mb-6 bg-yellow-500"></div>
      <p className="max-w-3xl mx-auto text-xl text-gray-600">
        Discover the exceptional features that make us Africa's premier educational institution
      </p>
    </div>

    {/* Features Grid */}
    <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      
      {/* Academic Excellence */}
      <div className="relative overflow-hidden transition-all duration-300 transform shadow-2xl group bg-gradient-to-br from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 rounded-2xl hover:scale-105">
        <div className="absolute inset-0 transition-opacity duration-300 bg-black opacity-0 group-hover:opacity-10"></div>
        <div className="relative z-10 p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="flex items-center justify-center w-20 h-20 bg-black rounded-full bg-opacity-20 backdrop-blur-sm">
              <FaAward className="text-4xl text-black" />
            </div>
          </div>
          <h3 className="mb-4 text-2xl font-bold tracking-wide text-black uppercase">
            Academic Excellence
          </h3>
          <p className="text-base leading-relaxed text-gray-900">
            Internationally aligned curriculum, highly qualified science educators, and small class sizes for personalized learning.
          </p>
        </div>
      </div>

      {/* State-of-the-Art Facilities */}
      <div className="relative overflow-hidden transition-all duration-300 transform shadow-2xl group bg-gradient-to-br from-green-700 to-green-800 hover:from-green-800 hover:to-green-900 rounded-2xl hover:scale-105">
        <div className="absolute inset-0 transition-opacity duration-300 bg-black opacity-0 group-hover:opacity-10"></div>
        <div className="relative z-10 p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="flex items-center justify-center w-20 h-20 bg-white rounded-full bg-opacity-20 backdrop-blur-sm">
              <FaMicroscope className="text-4xl text-white" />
            </div>
          </div>
          <h3 className="mb-4 text-2xl font-bold tracking-wide text-white uppercase">
            State-of-the-Art Facilities
          </h3>
          <p className="text-base leading-relaxed text-gray-100">
            Modern science labs with the latest technology, cutting-edge coding and robotics labs, and expansive libraries.
          </p>
        </div>
      </div>

      {/* Innovative Programs */}
      <div className="relative overflow-hidden transition-all duration-300 transform shadow-2xl group bg-gradient-to-br from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 rounded-2xl hover:scale-105">
        <div className="absolute inset-0 transition-opacity duration-300 bg-black opacity-0 group-hover:opacity-10"></div>
        <div className="relative z-10 p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="flex items-center justify-center w-20 h-20 bg-black rounded-full bg-opacity-20 backdrop-blur-sm">
              <FaFlask className="text-4xl text-black" />
            </div>
          </div>
          <h3 className="mb-4 text-2xl font-bold tracking-wide text-black uppercase">
            Innovative Programs
          </h3>
          <p className="text-base leading-relaxed text-gray-900">
            Robotics and coding clubs, science fairs and competitions, and internship opportunities with industry partners.
          </p>
        </div>
      </div>

      {/* Holistic Development */}
      <div className="relative overflow-hidden transition-all duration-300 transform shadow-2xl group bg-gradient-to-br from-gray-800 to-gray-900 hover:from-gray-900 hover:to-black rounded-2xl hover:scale-105">
        <div className="absolute inset-0 transition-opacity duration-300 bg-yellow-500 opacity-0 group-hover:opacity-10"></div>
        <div className="relative z-10 p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="flex items-center justify-center w-20 h-20 bg-yellow-500 rounded-full bg-opacity-20 backdrop-blur-sm">
              <FaUsers className="text-4xl text-yellow-500" />
            </div>
          </div>
          <h3 className="mb-4 text-2xl font-bold tracking-wide text-white uppercase">
            Holistic Development
          </h3>
          <p className="text-base leading-relaxed text-gray-100">
            Character-building programs, extracurricular activities, and mentorship from successful alumni.
          </p>
        </div>
      </div>

      {/* Community Engagement */}
      <div className="relative overflow-hidden transition-all duration-300 transform shadow-2xl group bg-gradient-to-br from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 rounded-2xl hover:scale-105">
        <div className="absolute inset-0 transition-opacity duration-300 bg-black opacity-0 group-hover:opacity-10"></div>
        <div className="relative z-10 p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="flex items-center justify-center w-20 h-20 bg-black rounded-full bg-opacity-20 backdrop-blur-sm">
              <FaBookOpen className="text-4xl text-black" />
            </div>
          </div>
          <h3 className="mb-4 text-2xl font-bold tracking-wide text-black uppercase">
            Community Engagement
          </h3>
          <p className="text-base leading-relaxed text-gray-900">
            Partnerships with local industries, service learning and community outreach, and an active Parent-Teacher Forum.
          </p>
        </div>
      </div>

      {/* Our Achievements */}
      <div className="relative overflow-hidden transition-all duration-300 transform shadow-2xl group bg-gradient-to-br from-green-700 to-green-800 hover:from-green-800 hover:to-green-900 rounded-2xl hover:scale-105">
        <div className="absolute inset-0 transition-opacity duration-300 bg-black opacity-0 group-hover:opacity-10"></div>
        <div className="relative z-10 p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="flex items-center justify-center w-20 h-20 bg-white rounded-full bg-opacity-20 backdrop-blur-sm">
              <FaTrophy className="text-4xl text-white" />
            </div>
          </div>
          <h3 className="mb-4 text-2xl font-bold tracking-wide text-white uppercase">
            Our Achievements
          </h3>
          <p className="text-base leading-relaxed text-gray-100">
            Consistently high graduation rates, multiple awards in national science competitions, and alumni success in leading STEM industries.
          </p>
        </div>
      </div>
    </div>

    {/* Call to Action */}
    <div className="mt-16 text-center">
      <button className="px-12 py-4 text-lg font-bold tracking-wider text-black uppercase transition-all duration-300 transform rounded-full shadow-xl bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 hover:scale-105">
        Learn More About Our Programs
      </button>
    </div>
  </div>
</section>
        <Footer />
      </div>
    </div>
  );
};

export default AboutPage;
